/* eslint-disable react/jsx-indent */
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import { PropTypes } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import {
  Formik, Form,
} from 'formik';
import Select from '@material-ui/core/Select';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import OutlinedInput from '@material-ui/core/OutlinedInput';

import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import Skeleton from 'react-loading-skeleton';
import { withRouter } from 'react-router-dom';
import AddCircle from '@material-ui/icons/AddCircle';
import { connect } from 'react-redux';
import NotificationBar from '@trdk/style/NotificationBar';
import Hidden from '@material-ui/core/Hidden';
import { Divider } from '@material-ui/core';
import StandardInput from './standardinput';
import AddParty from './add-party';
import { putParty, fetchPartiesName } from '../services/admin/party-service';
import { doFetch, fetchClear } from '../services/fetch/fetch.actions';


class DefaultForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addParty: {},
    };
  }

  loadParties = () => (dispatch) => {
    dispatch(doFetch(
      'PARTIES_NAME',
      fetchPartiesName()
        .then((res) => {
          if (!res.ok) {
            throw res.statusText;
          }
          return res.json();
        }),
    ));
  }

  componentDidMount = () => {
    const { partiesName: { fetched, fetching }, dispatch } = this.props;
    if (!fetched && !fetching) {
      dispatch(this.loadParties());
    }
  }

  fetchaddPartyfunction = (name) => {
    const { addParty } = this.state;
    const { dispatch } = this.props;

    putParty({
      name: name.toLowerCase(),
      display: name,
      active: true,
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        this.setState({ addParty: { ...addParty, [name]: 'success' } });
        dispatch(fetchClear('PARTIES'));
        dispatch(fetchClear('PARTIES_NAME'));
        dispatch(this.loadParties());
      }).catch(() => this.setState({ addParty: { ...addParty, [name]: 'error' } }));
  }

  render() {
    const {
      classes,
      initialValues: defaultvalues,
      onSubmit: submit,
      history,
      isLoading,
      dispatch,
      partiesName: {
        payload: { Resources: parties },
        fetching,
        fetched,
        error: fetchError,
      },
      schema,
      requiredFields,
      isAdmin,
      disabledFields,
      additionalInfo,
      pending,
      hideButtons,
      handleCancel,
      editing,
    } = this.props;

    const { addParty } = this.state;

    return (
      <Formik
        initialValues={defaultvalues}
        validationSchema={schema}
        onSubmit={submit}
      >
        {({
          values,
          handleChange,
          errors,
          handleBlur,
          handleFocus,
          touched,
          initialValues,
          setFieldValue,
          setTouched,
        }) => {
          const combo = {
            classes, errors, touched, handleBlur, initialValues,
          };
          return (
            <Form className={classes.form}>
              <AddParty
                open={values.parti === 'addnewparty'}
                handleCancel={() => {
                  setFieldValue('parti', '');
                  setTouched({ parti: false });
                }}
                handleAccept={(name) => {
                  setFieldValue('parti', name);
                  setTouched({ parti: false });
                  this.fetchaddPartyfunction(name);
                }}
                onEnter={() => this.setState({ addParty: {} })}
              />
              <Grid
                container
                spacing={2}
              >
                <Grid item xs={12}><Typography variant="body1" color="primary">Parti</Typography></Grid>
                <Grid item className={classes.gridItem} sm={6} xs={12}>
                  {(!fetchError && fetching) ? <Skeleton height="3.5rem" /> : (
                    <FormControl variant="outlined" className={classes.party}>
                      <InputLabel required={requiredFields} htmlFor="parti">Parti</InputLabel>
                      <Select
                        variant="outlined"
                        value={values.parti || ''}
                        onChange={handleChange}
                        error={!!errors.parti && touched.parti}
                        input={<OutlinedInput labelWidth={43} name="par" id="outlined-par-simple" />}
                        inputProps={{
                          name: 'parti',
                          id: 'parti',
                        }}
                        onBlur={handleBlur}
                        onFocus={handleFocus}
                        disabled={disabledFields.parti}
                      >
                        {fetched && parties && parties.filter(item => item.active).map(item => (
                          <MenuItem value={item.id} key={item.id}>
                            {item.display || item.name}
                          </MenuItem>
                        ))}
                        {isAdmin
                        && (
                          <MenuItem value="addnewparty" key="addnewparty" className={classes.addpartyitem}>
                            <AddCircle className={classes.addicon} />
                          Legg til parti
                          </MenuItem>
                        )
                        }
                      </Select>
                      {touched.parti && errors.parti ? (
                        <FormHelperText error={!!errors.parti && touched.parti}>
                          {touched.parti && errors.parti}
                        </FormHelperText>
                      ) : (
                        <FormHelperText>
                          Velg politisk parti
                        </FormHelperText>
                      )}
                    </FormControl>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <Divider className={classes.dividerParty} />
                  <Typography variant="body1" color="primary">Personlige opplysninger</Typography>
                  <Typography variant="body2" color="textSecondary">{additionalInfo}</Typography>
                </Grid>
                <StandardInput
                  name="fnr"
                  label="Fødselsnummer"
                  size={6}
                  helperText="11 siffer"
                  onChange={(e) => {
                    setFieldValue('gender', values.fnr[8] % 2 === 0 ? 'Kvinne' : 'Mann');
                    handleChange(e);
                  }}
                  combo={combo}
                  required={requiredFields}
                  isLoading={isLoading}
                  disabled={disabledFields.fnr}
                  placeholder={editing ? '***********' : ''}
                  InputLabelProps={editing ? {
                    shrink: true,
                  } : {}}
                />
                <Grid item className={classes.gridItem} sm={5} xs={12}>
                  {isLoading ? <Skeleton height="3.5rem" /> : (
                    <TextField
                      type="text"
                      name="gender"
                      label="Kjønn"
                      variant="outlined"
                      onBlur={handleBlur}
                      value={values.gender}
                      onChange={handleChange}
                      error={!!errors.gender && touched.gender}
                      helperText={(errors.gender && touched.gender) ? errors.gender : '9. siffer i fødselsnummeret brukes til å finne kjønn'}
                      disabled
                    />
                  )}
                </Grid>
                {['Fornavn', 'Etternavn', 'Epost'].map(name => (
                  <StandardInput
                    label={name}
                    key={name}
                    size={6}
                    onChange={handleChange}
                    combo={combo}
                    required={requiredFields}
                    isLoading={isLoading}
                    disabled={disabledFields[name.toLowerCase()]}
                  />
                ))}
                <StandardInput name="tlfprivat" label="Telefon" size={4} adornment="+47" onChange={handleChange} combo={combo} required={requiredFields} isLoading={isLoading} disabled={disabledFields.tlfprivat} />
                <Grid item xs={12}>
                  <Divider className={classes.divider} />
                </Grid>
                {['Adresse', 'Postnr', 'Poststed'].map(name => (
                  <StandardInput
                    label={name}
                    key={name}
                    // eslint-disable-next-line no-nested-ternary
                    size={name === 'Postnr' ? 2 : name === 'Poststed' ? 4 : 6}
                    onChange={handleChange}
                    combo={combo}
                    required={requiredFields}
                    isLoading={isLoading}
                    disabled={disabledFields[name.toLowerCase()]}
                  />
                ))}
                <Grid item xs={12}>
                  <Divider className={classes.divider} />
                  <Typography variant="body1" color="primary">Arbeid</Typography>
                </Grid>
                <StandardInput
                  label="Arbeidssted"
                  size={4}
                  onChange={handleChange}
                  combo={combo}
                  // required={requiredFields}
                  isLoading={isLoading}
                  disabled={disabledFields.arbeidssted}
                />
                <Grid item xs={12}>
                  <Divider className={classes.divider} />
                </Grid>
                <StandardInput
                  label="Bankkontonummer"
                  size={4}
                  onChange={handleChange}
                  combo={combo}
                  required={requiredFields}
                  isLoading={isLoading}
                  disabled={disabledFields.bankkontonummer}
                />
                <StandardInput name="generalInfo" label="Relevant informasjon" size={12} onChange={handleChange} combo={combo} multiline rows={4} isLoading={isLoading} disabled={disabledFields.generalInfo} />
                {!hideButtons
                  && [
                    (
                      <Hidden only="xs" key={1}>
                        <Grid item xs={4} />
                      </Hidden>
                    ),
                    (
                      <Grid item xs={6} sm={4} key={2}>
                        <Button
                          variant="outlined"
                          className={classes.cancel}
                          onClick={handleCancel || (() => {
                            dispatch(fetchClear('ADD_PARTY')); dispatch(fetchClear('EDIT_POLITICIAN')); dispatch(fetchClear('ADD_POLITICIAN'));
                            // eslint-disable-next-line no-unused-expressions
                            (isAdmin ? history.push('/admin') : history.push('/'));
                          })}
                          disabled={disabledFields.cancel}
                          fullWidth
                        >
                        Avbryt
                        </Button>
                      </Grid>
                    ),
                    (
                      <Grid item xs={6} sm={4} key={3}>
                        <Button
                          color="primary"
                          variant="contained"
                          type="submit"
                          className={pending ? classes.submitActivate : classes.submit}
                          disabled={isLoading || disabledFields.submit}
                          fullWidth
                        >
                          {pending ? 'Lagre og aktiver' : 'Lagre'}
                        </Button>
                      </Grid>
                    )]}
              </Grid>
              {fetchError && <NotificationBar message="Feil ved henting av partier" variant="error" />}
              {Object.values(addParty).includes('error') && <NotificationBar message="Feil ved oppretting av parti" variant="error" />}
              {Object.values(addParty).includes('success') && <NotificationBar message="Parti opprettet" variant="success" />}
            </Form>
          );
        }}
      </Formik>
    );
  }
}

const styles = theme => ({
  divider: {
    marginBottom: '0.5rem',
    marginTop: '0.3rem',
  },
  dividerParty: {
    marginTop: '0rem',
    marginBottom: '0.5rem',
  },
  submit: {
    marginTop: '1rem',
  },
  form: {
    maxWidth: '60rem',
    marginTop: '1rem',
    flexGrow: 1,
  },
  cancel: {
    marginTop: '1rem',
    height: 'calc(100% - 1rem)',
  },
  gridItem: {
    paddingLeft: '0.8rem',
  },
  textfield: {
    width: '100%',
  },
  party: {
    width: '100%',
  },
  addpartyitem: {
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    '&:hover': {
      color: '#000',
    },
  },
  addicon: {
    marginRight: '1rem',
  },
  submitActivate: {
    marginTop: '1rem',
    '&:hover': {
      backgroundColor: '#00953b',
      color: '#fff',
    },
  },
});

DefaultForm.propTypes = {
  classes: PropTypes.object.isRequired,
  initialValues: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  history: PropTypes.any.isRequired,
  isLoading: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  partiesName: PropTypes.any.isRequired,
  schema: PropTypes.any.isRequired,
  requiredFields: PropTypes.bool,
  isAdmin: PropTypes.bool,
  disabledFields: PropTypes.object,
  additionalInfo: PropTypes.string,
  pending: PropTypes.bool,
  hideButtons: PropTypes.bool,
  handleCancel: PropTypes.any,
  editing: PropTypes.bool,
};

DefaultForm.defaultProps = {
  isLoading: false,
  requiredFields: false,
  isAdmin: false,
  disabledFields: {},
  additionalInfo: undefined,
  pending: false,
  hideButtons: false,
  handleCancel: undefined,
  editing: false,
};

const mapStateToProps = ({ partiesName }) => ({ partiesName });

export default connect(mapStateToProps)(withRouter(withStyles(styles)(DefaultForm)));
